import { apiClient } from './client';

/** Mensaje editable del bot (réplica de "Mensajes Automáticos" de Charly). */
export interface BotMessage {
  key: string;
  category: string;
  label: string;
  body: string;
  default: string;
  isOverridden: boolean;
  variables: string[];
}

export const botMessagesApi = {
  list: async (): Promise<BotMessage[]> => {
    const { data } = await apiClient.get('/admin/bot-messages');
    return data as BotMessage[];
  },

  update: async (key: string, body: string): Promise<BotMessage[]> => {
    const { data } = await apiClient.put(`/admin/bot-messages/${key}`, { body });
    return data as BotMessage[];
  },

  reset: async (key: string): Promise<BotMessage[]> => {
    const { data } = await apiClient.delete(`/admin/bot-messages/${key}`);
    return data as BotMessage[];
  },
};
